<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="350">
      <v-card>
        <v-card-text v-if="message">{{ message }}</v-card-text>
        <v-card-text>Are you sure want to continue?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="close()">Cancel</v-btn>
          <v-btn color="green" flat @click="ok()">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'Confirm',
  props: {
    message: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dialog: true
    }
  },
  methods: {
    close () {
      this.$emit('closePop', false)
      this.dialog = false
    },
    ok () {
      this.$emit('submit')
      this.dialog = false
    }
  },
  watch: {
    dialog () {
      setTimeout(() => {
        this.dialog = false
      }, 300)
    }
  }
}
</script>

<style scoped>
.primary--text, .green--text {
  color: rgb(77, 189, 153)!important;
}

.green {
  background: rgb(77, 189, 153)!important;
}
</style>
